
export default function About() {
  return (
    <section id="about" className="w-full py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-24" style={{ backgroundColor: '#F5F1E8' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-20">
          {/* Left Column */}
          <div className="lg:col-span-3">
            <div
              className="text-xl md:text-2xl lg:text-3xl font-light leading-relaxed text-gray-800"
              style={{ fontFamily: 'Cormorant Garamond, serif', lineHeight: '1.8' }}
            >
              <p className="mb-6">
                Vonnes Alpine Life was born from a deep-rooted love for the Abondance Valley and a desire to see Châtel's mountains enjoyed by everyone. As the owners of Chalet Lac de Vonnes, our journey began with a commitment to preserving the luxury and charm of traditional alpine living.
              </p>
              <p className="mb-6">
                However, we recognised that the mountains should be accessible to more than just traditional skiers and boarders. We saw an opportunity to bring something truly innovative to our corner of the Portes du Soleil—a way to combine the thrill of the slopes with modern stability and inclusivity.
              </p>
              <p>
                By establishing the first ever Skki Trikke Hub for the Portes du Soleil, we aren't just renting equipment; we are introducing a new way to move. Whether you are a seasoned mountain lover looking for a fresh perspective, or someone seeking a more stable alternative to skiing, our mission is to ensure your time in the Alps is safe, exhilarating, and unforgettable.
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-2 flex items-start lg:pt-16">
            <div className="w-full rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://www.dropbox.com/scl/fi/6ijtjweav8jo2ts4i72f4/Photo-25-02-2026-19-32-00.jpg?rlkey=za23t0apnz8mql0er26rk309f&st=droku8ks&raw=1"
                alt="Luxury Chalet Interior"
                className="w-full h-64 md:h-80 lg:h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
